import React, { createContext, useContext, useState, useEffect } from 'react';
import ConfigDataService from '../services/config/ConfigService';

// Create the Academic Year Context
const AcademicYearContext = createContext();

// Academic Year Provider Component
export const AcademicYearProvider = ({ children }) => {
  const [activeYear, setActiveYear] = useState(null);
  const [activeSemester, setActiveSemester] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAcademicYear = async () => {
      try {
        setError(null);
        const { activeYear: ay, activeSemester: as } = await ConfigDataService.getActiveYearAndSemesterFromSemesterDates();
        setActiveYear(ay);
        setActiveSemester(as);
      } catch (err) {
        console.error('Error fetching academic year:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAcademicYear();
  }, []);

  const value = {
    activeYear,
    activeSemester,
    loading,
    error,
  };

  return (
    <AcademicYearContext.Provider value={value}>
      {children}
    </AcademicYearContext.Provider>
  );
};

// Custom hook to use the Academic Year Context
export const useAcademicYear = () => {
  const context = useContext(AcademicYearContext);
  if (!context) {
    throw new Error('useAcademicYear must be used within an AcademicYearProvider');
  }
  return context;
};
